import React from 'react';
import { useRouteMeta } from '../hooks/useRouteMeta';
import { useT } from '../i18n/useT';
import RouteHero from '../components/RouteHero';
import OnePlatform from '../components/OnePlatform';
import ConnectData from '../components/ConnectData';
import SemanticLayer from '../components/SemanticLayer';
import BuildWithWAI from '../components/BuildWithWAI';
import Deployment from '../components/Deployment';
import ConnectivityGuide from '../components/ConnectivityGuide';
import TaglineBanner from '../components/TaglineBanner';
import BackToOverview from '../components/BackToOverview';

const PlatformPage: React.FC = () => {
  useRouteMeta('platform');
  const { r } = useT();
  return (
    <>
      <RouteHero
        eyebrow={r.routes.platform.eyebrow}
        title={r.routes.platform.heroTitle}
        subtitle={r.routes.platform.heroSubtitle}
      />
      <OnePlatform />
      <ConnectData />
      <SemanticLayer />
      <BuildWithWAI />
      <Deployment />
      <ConnectivityGuide />
      <TaglineBanner />
      <BackToOverview />
    </>
  );
};

export default PlatformPage;
